import "../../assets/style/grandprix.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CircuitLayout from "../../components/CircuitLayout";
import CircuitTransition from "../../components/CircuitTransition";
import {
  faCircleInfo,
  faCalendarDay,
  faLocationPin,
  faRuler,
  faBacon,
  faMapLocation,
  faTrophy,
  faGaugeHigh,
  faNewspaper,
  faPen,
  faTrash,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { i18n } from "../../App";
import DateFormat from "../../components/DateFormat";
import Flag from "../../components/Flag";
import { DriverLink } from "../../components/FlagLink";
import ErrorPage from "../ErrorPage";
import { Link, useNavigate } from "react-router-dom";
import GrandPrixNavbar from "../../components/GrandPrix/GrandPrixNavbar";
import LoadingContent from "../../components/LoadingContent";
import SummaryData from "../../components/Historic/SummaryData";
import SummaryDrivers from "./index/SummaryDrivers";
import { useUser } from "../../components/UserContext";
import { processMilestoneAuto } from "../../utils/Milestones";

const GrandPrix = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  let { grandprix } = useParams();
  const { superMode, user } = useUser() as any;
  const { t } = useTranslation();
  const [grandPrix, setGrandPrix] = useState<any>({
    name: "",
    pole_video: "",
    gp_video: "",
    conference: "",
    circuit_id: null,
    date: new Date(),
    circuit_name: "",
    layout: null,
    turns: 0,
    length: 0,
    flag_code: "unk",
    country: "",
    id: -1,
    champ_name: "",
    rally_circuits: "",
  });
  const [editingMilestoneIndex, setEditingMilestoneIndex] = useState<
    number | null
  >(null);
  const [editedMilestoneText, setEditedMilestoneText] = useState("");
  const [milestones, setMilestones] = useState([]);
  const [typeRaces, setTypeRaces] = useState(-1);
  const [drivers, setDrivers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [grandsPrixNames, setGrandsPrixNames] = useState([]);
  const [winner, setWinner] = useState([]);
  const [report, setReport] = useState<any>([]);

  const [poleman, setPoleman] = useState([]);
  const [fastestLap, setFastestLap] = useState([]);
  const [photoGP, setPhotoGP] = useState("");

  const [widthCont, setWidthCont] = useState("col-md-8");
  const [circuitContainer, setCircuitContainer] = useState(
    "gp-results-layout-container",
  );

  useEffect(() => {
    console.log(superMode, user);
    // 1. Reseteamos los contenedores a sus valores por defecto antes de cargar el nuevo GP
    setWidthCont("col-md-8");
    setCircuitContainer("gp-results-layout-container");
    setLoading(true);

    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/grandprix/getGrandPrixByName`,
        {
          params: {
            name: grandprix,
            language: i18n.language,
          },
        },
      )
      .then(({ data }) => {
        document.title = "LVF1 - " + data.grand_prix.name;
        setMilestones(data.milestones);
        setDrivers(data.drivers);
        setTeams(data.teams);
        setGrandsPrixNames(data.grandprix_names);
        setWinner(data.winner);
        setPoleman(data.poleman);
        setFastestLap(data.fastestLap);
        setGrandPrix(data.grand_prix);
        setTypeRaces(data.type_races);
        setReport(data.report);

        if (
          data.grand_prix.gp_video === null ||
          data.grand_prix.pole_video === null
        ) {
          if (data.hasImage != null && data.hasImage)
            setPhotoGP(`/assets/ImagesGP/${data.grand_prix.id}.jpg`);
          else if (
            data.grand_prix.pole_video === null &&
            data.grand_prix.gp_video === null
          ) {
            setWidthCont("col-md-12");
          }
        }

        // 2. Si el nuevo GP no tiene hitos, aplicamos la clase especial
        if (data.milestones.length == 0) {
          setCircuitContainer("gp-results-layout-containerx2");
        }

        setLoading(false);
      })
      .catch(({ response }) => {
        setLoading(false);
        throw new Error(response?.data || response);
      });
  }, [i18n.language, grandprix]);
  const handleUpdateMilestone = (milestoneId: number, index: number) => {
    const baseURL =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500";

    axios
      .post(`${baseURL}/api/grandprix/updateMilestone`, {
        id: milestoneId,
        milestone: editedMilestoneText,
      })
      .then(() => {
        // Actualizamos el estado localmente para reflejar el cambio sin recargar
        const updatedMilestones: any = [...milestones];
        updatedMilestones[index].milestone = editedMilestoneText;
        setMilestones(updatedMilestones);
        setEditingMilestoneIndex(null);
      })
      .catch((error) => {
        console.error("Error updating milestone:", error);
      });
  };

  const handleDeleteMilestone = (milestoneId: number, index: number) => {
    if (!window.confirm("¿Estás seguro de que deseas eliminar este milestone?"))
      return;

    const baseURL =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500";

    axios
      .post(`${baseURL}/api/grandprix/deleteMilestone`, {
        id: milestoneId,
      })
      .then(() => {
        // Eliminamos el milestone del estado local
        const updatedMilestones = milestones.filter((_, i) => i !== index);
        setMilestones(updatedMilestones);
      })
      .catch((error) => {
        console.error("Error deleting milestone:", error);
      });
  };
  const escapeRegExp = (string: string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& significa toda la cadena coincidente
  };
  const getMilestoneLinked = (milestone: string | null): any => {
    if (milestone == null) return milestone;
    let milestone_array: any[] = [milestone];

    // Función auxiliar para procesar colecciones de forma limpia
    const processEntities = (
      entities: any[],
      prefix: string,
      currentMilestone: any[],
    ) => {
      // Ordenar estrictamente de mayor a menor longitud para evitar conflictos parciales
      const sortedEntities = [...entities].sort((a: any, b: any) => {
        const nameA = a.username || a.name;
        const nameB = b.username || b.name;
        return nameB.length - nameA.length;
      });

      return sortedEntities.reduce((previous_milestone: any[], entity: any) => {
        const entityName = entity.username || entity.name;
        let return_milestone: any[] = previous_milestone.slice();

        for (var i = 0; i < previous_milestone.length; i++) {
          if (previous_milestone[i].startsWith("{")) {
            continue;
          }

          // Usamos límites de palabra (\b) para evitar coincidencias parciales (ej. "BAR" en "barrera")
          var escapedName = escapeRegExp(entityName);
          var re = new RegExp(`\\b(${escapedName})\\b`, "gi");

          if (!re.test(previous_milestone[i])) {
            continue;
          }

          // Reset lastIndex debido al uso de 'g' con .test()
          re.lastIndex = 0;
          var aux = previous_milestone[i].split(re);

          return_milestone.splice(i, 1);

          let offset = 0;
          for (var j = 0; j < aux.length; j++) {
            let segment: any = aux[j];
            // Comprobación insensible a mayúsculas/minúsculas pero respetando el texto original
            if (segment.toLowerCase() === entityName.toLowerCase()) {
              segment = prefix + segment;
            }
            return_milestone.splice(i + offset, 0, segment);
            offset++;
          }
          i += offset - 1;
        }
        return return_milestone;
      }, currentMilestone);
    };

    /* 1. DRIVERS */
    let transformed = processEntities(drivers, "{DR}", milestone_array);

    /* 2. TEAMS */
    transformed = processEntities(teams, "{TE}", transformed);

    /* 3. GPS */
    transformed = processEntities(grandsPrixNames, "{GP}", transformed);

    /* Renderizado final de los componentes React */
    let output_milestone: any = <></>;
    return transformed.reduce(
      (previous_milestone: any, current_position: any) => {
        if (current_position.startsWith("{DR}")) {
          let driver = current_position.split("{DR}")[1];
          return (
            <>
              {previous_milestone}
              <Link
                to={`${t("routes:Driver")}/${encodeURIComponent(driver)}`}
                className="driver"
              >
                {driver}
              </Link>
            </>
          );
        } else if (current_position.startsWith("{TE}")) {
          let team = current_position.split("{TE}")[1];
          return (
            <>
              {previous_milestone}
              <Link
                to={`${t("routes:Team")}/${encodeURIComponent(team)}`}
                className="driver"
              >
                {team}
              </Link>
            </>
          );
        } else if (current_position.startsWith("{GP}")) {
          let gp = current_position.split("{GP}")[1];
          return (
            <>
              {previous_milestone}
              <Link
                to={`${t("routes:GrandPrix")}/${encodeURIComponent(gp.replace(/ /g, ""))}`}
                className="driver"
              >
                {gp}
              </Link>
            </>
          );
        }
        return (
          <>
            {previous_milestone}
            <span>{current_position}</span>
          </>
        );
      },
      output_milestone,
    );
  };

  if (loading) return <LoadingContent />;
  if (grandPrix.name === "" || grandprix == null) return <ErrorPage />; //just in case gp name does not exist
  return (
    <div className="full-height padding-md app-container page-transition">
      <GrandPrixNavbar name={grandprix} active={1} />
      <div id="index-gp-container" className="row">
        <div className={widthCont}>
          <div
            className="flex"
            id={grandPrix.conference !== null ? "gp-data-withconf" : "gp-data"}
          >
            <div className="col-md-6">
              <div id="gp-overview" className="frame-turqoise frame-sm">
                <p className="main-title noBottomMargin frame-title">
                  {t("Summary").toUpperCase()}
                </p>
                <div id="summary-data-content">
                  <p className="flex">
                    <FontAwesomeIcon icon={faCalendarDay} />
                    <b>{t("Date")}: </b>
                    <DateFormat
                      date={grandPrix.date.toString()}
                      format={"normal"}
                    />
                  </p>
                  <p className="flex">
                    <FontAwesomeIcon icon={faLocationPin} />
                    <b>
                      {grandPrix.rally_circuits == null
                        ? t("Circuit")
                        : t("Stages")}
                      :{" "}
                    </b>
                    <span>
                      {grandPrix.rally_circuits == null
                        ? grandPrix.layout === null
                          ? `${grandPrix.circuit_name}`
                          : `${grandPrix.circuit_name} (${grandPrix.layout.replace(/\s+V\d+$/, "")})`
                        : `${grandPrix.rally_circuits}`}
                    </span>
                  </p>
                  {grandPrix.turns > 0 && (
                    <p className="flex">
                      <FontAwesomeIcon icon={faBacon} />
                      <b>{t("Turns")}: </b>
                      <span>{grandPrix.turns}</span>
                    </p>
                  )}
                  {grandPrix.length != null && (
                    <p className="flex">
                      <FontAwesomeIcon icon={faRuler} />
                      <b>{t("Length")}: </b>
                      <span>
                        {parseFloat(grandPrix.length.toString()).toFixed(3)} km
                      </span>
                    </p>
                  )}
                  {grandPrix.country !== null && (
                    <p className="flex">
                      <FontAwesomeIcon icon={faMapLocation} />
                      <b>{t("Location")}: </b>
                      <span>
                        <Flag
                          flag_code={grandPrix.flag_code}
                          name={grandPrix.country}
                        />
                        {t(`countries:${grandPrix.country}`)}
                      </span>
                    </p>
                  )}
                  {typeRaces !== 1 && poleman != null && (
                    <SummaryDrivers
                      code="PO"
                      translation="Polesitter"
                      drivers={Array.isArray(poleman) ? poleman : [poleman]}
                      icon={faGaugeHigh}
                    />
                  )}
                  <SummaryDrivers
                    code="WI"
                    translation="Winner"
                    drivers={winner}
                    icon={faTrophy}
                  />
                  <SummaryDrivers
                    code="FL"
                    translation="HotLap"
                    drivers={fastestLap}
                    icon={faGaugeHigh}
                  />
                </div>
                {report.length > 0 && (
                  <div
                    className="race-report flex"
                    onClick={() => {
                      navigate(
                        `${t("routes:News")}/${
                          grandPrix.champ_name == null
                            ? "LVF1"
                            : grandPrix.champ_name.replace(/ /g, "")
                        }/${report[0].id}`,
                      );
                    }}
                  >
                    <img
                      alt={grandPrix.name}
                      src={`/assets/News/${report[0].id}/Image.jpg`}
                    />
                    <div>
                      <h4>
                        {i18n.language === "es"
                          ? report[0].title_es
                          : report[0].title_en}
                      </h4>
                      <span>
                        {i18n.language === "es"
                          ? report[0].caption_es
                          : report[0].caption_en}
                      </span>
                    </div>
                    <div className="read-more">{t("Report")}</div>
                  </div>
                )}
                {grandPrix.conference !== null && (
                  <div id="press-conference">
                    <iframe
                      id="audio_53222826"
                      scrolling="no"
                      height="200"
                      width="100%"
                      src={`https://www.ivoox.com/player_ej_${grandPrix.conference}_6_1.html?c1=101010`}
                      loading="lazy"
                    ></iframe>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6 flex-around">
              <div id={circuitContainer} className="frame-turqoise frame-sm">
                <p className="main-title frame-title noBottomMargin">
                  {grandPrix.circuit_name.toUpperCase()}
                </p>
                <div>
                  {grandPrix.circuit_id !== null &&
                    (grandPrix.circuit_id.includes(",") ? (
                      <CircuitTransition
                        circuits_id={grandPrix.circuit_id}
                        circuits_name={grandPrix.rally_circuits}
                        id_canvas={`circuit-${grandPrix.id}`}
                      />
                    ) : (
                      <CircuitLayout
                        circuit_id={grandPrix.circuit_id}
                        id_canvas={`circuit-${grandPrix.id}`}
                      />
                    ))}
                </div>
              </div>
              {milestones.length > 0 && (
                <div
                  id="milestones-container"
                  className="frame-turqoise frame-sm"
                >
                  <p className="main-title frame-title noBottomMargin">
                    {t("Milestones").toUpperCase()}
                  </p>
                  <div className="milestones-data">
                    {milestones.map((milestone: any, index) => {
                      return (
                        <p key={index}>
                          <FontAwesomeIcon icon={faCircleInfo} />{" "}
                          {milestone.milestone != null ? (
                            <React.Fragment>
                              {editingMilestoneIndex === index ? (
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    width: "100%",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <input
                                    type="text"
                                    value={editedMilestoneText}
                                    onChange={(e) =>
                                      setEditedMilestoneText(e.target.value)
                                    }
                                    style={{ flex: 1, minWidth: "150px" }}
                                  />
                                  <button
                                    title="Guardar"
                                    onClick={() =>
                                      handleUpdateMilestone(milestone.id, index)
                                    }
                                    style={{
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      padding: "2px 5px",
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faCheck}
                                      style={{ color: "green" }}
                                    />
                                  </button>
                                  <button
                                    title="Cancelar"
                                    onClick={() =>
                                      setEditingMilestoneIndex(null)
                                    }
                                    style={{
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      padding: "2px 5px",
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faTimes}
                                      style={{ color: "gray" }}
                                    />
                                  </button>
                                </span>
                              ) : (
                                <React.Fragment>
                                  {getMilestoneLinked(milestone.milestone)}
                                  {superMode && (
                                    <span
                                      style={{
                                        marginLeft: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <button
                                        title="Editar"
                                        onClick={() => {
                                          setEditingMilestoneIndex(index);
                                          setEditedMilestoneText(
                                            milestone.milestone,
                                          );
                                        }}
                                        style={{
                                          background: "none",
                                          border: "none",
                                          cursor: "pointer",
                                          marginRight: "5px",
                                          padding: "2px",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faPen}
                                          style={{ fontSize: "0.85em" }}
                                        />
                                      </button>
                                      <button
                                        title="Eliminar"
                                        onClick={() =>
                                          handleDeleteMilestone(
                                            milestone.id,
                                            index,
                                          )
                                        }
                                        style={{
                                          background: "none",
                                          border: "none",
                                          cursor: "pointer",
                                          padding: "2px",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faTrash}
                                          style={{
                                            color: "#d9534f",
                                            fontSize: "0.85em",
                                          }}
                                        />
                                      </button>
                                    </span>
                                  )}
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          ) : (
                            getMilestoneLinked(
                              processMilestoneAuto(milestone, t),
                            )
                          )}
                        </p>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-4">
          {grandPrix.pole_video && (
            <div className="video-container frame-turqoise frame-sm">
              <p className="main-title frame-title noBottomMargin">
                {(typeRaces !== 1
                  ? t("PoleVideo")
                  : t("FastestLapVideo")
                ).toUpperCase()}
              </p>
              <iframe
                id="ytplayer"
                width="100%"
                allowFullScreen
                src={`https://www.youtube.com/embed/${grandPrix.pole_video}`}
              />
            </div>
          )}
          {grandPrix.gp_video && (
            <div className="video-container frame-turqoise frame-sm">
              <p className="main-title frame-title noBottomMargin">
                {t("GPVideo").toUpperCase()}
              </p>
              <iframe
                id="ytplayer"
                width="100%"
                allowFullScreen
                src={`https://www.youtube.com/embed/${grandPrix.gp_video}`}
              />
            </div>
          )}
          {photoGP !== "" && (
            <div className="image-container frame-turqoise frame-sm">
              <p className="main-title frame-title noBottomMargin">
                {t("PhotoGP").toUpperCase()}
              </p>
              <div className="flex-center">
                <img alt={grandPrix.name} src={photoGP} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GrandPrix;
